

import {Component, Mixins, Ref, Watch} from "vue-property-decorator";
import GenelIslemFormWizard, {GenelIslemEntity} from "@/components/forms/form-wizard/eicrapro/GenelIslemFormWizard.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {UyapHacizEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapHacizEvrakTuru";
import {AvukatTalepListCevapRow} from "@/plugins/uyap-plugin/uyap/AvukatTalepList";
import {ITask, Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import {VForm} from "@/types";
import AvukatTalepPicker from "@/components/pickers/uyap/AvukatTalepPicker.vue";
import PersonelPicker from "@/components/pickers/PersonelPicker.vue";
import {UyapDigerEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapDigerEvrakTuru";
import AcizBelgesiHazirlanmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/AcizBelgesiHazirlanmasiTalepEvrakForm.vue";
import AracUzerindekiHacizSerhininKaldirilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/AracUzerindekiHacizSerhininKaldirilmasiTalepEvrakForm.vue";
import AracUzerindekiYakalamaSerhininKaldirilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/AracUzerindekiYakalamaSerhininKaldirilmasiTalepEvrakForm.vue";
import BankadanHacizliParaninIstenilmesiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/BankadanHacizliParaninIstenilmesiTalepEvrakForm.vue";
import BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiTalepEvrakForm.vue";
import DosyadaHacizliMalinSatisiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/DosyadaHacizliMalinSatisiTalepEvrakForm.vue";
import DosyadakiAvansinIadesiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/DosyadakiAvansinIadesiTalepEvrakForm.vue";
import DosyadakiHacizlerinKaldirilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/DosyadakiHacizlerinKaldirilmasiTalepEvrakForm.vue";
import DosyadakiIbanBilgisininGuncellenmesiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/DosyadakiIbanBilgisininGuncellenmesiTalepEvrakForm.vue";
import DosyaninYetkiliIcraDairesineGonderilmesiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/DosyaninYetkiliIcraDairesineGonderilmesiTalepEvrakForm.vue";
import HacizliMalinKiymetTakdiriIcinTalimatYazilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/HacizliMalinKiymetTakdiriIcinTalimatYazilmasiTalepEvrakForm.vue";
import HacizliMalinSatisiIcinTalimatYazilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/HacizliMalinSatisiIcinTalimatYazilmasiTalepEvrakForm.vue";
import HacizliTasinirMallarinMuhafazaAltinaAlinmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/HacizliTasinirMallarinMuhafazaAltinaAlinmasiTalepEvrakForm.vue";
import HaricenTahsilatBildirimiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/HaricenTahsilatBildirimiTalepEvrakForm.vue";
import Iik121MaddeyeGoreYetkiVerilmesiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/Iik121MaddeyeGoreYetkiVerilmesiTalepEvrakForm.vue";
import Iik150cSerhiEklenmesiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/Iik150cSerhiEklenmesiTalepEvrakForm.vue";
import KiymetTakdirininYapilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/KiymetTakdirininYapilmasiTalepEvrakForm.vue";
import MaasUzerindekiHacizlerinKaldirilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/MaasUzerindekiHacizlerinKaldirilmasiTalepEvrakForm.vue";
import MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiTalepEvrakForm.vue";
import RehinAcigiBelgesiHazirlanmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/RehinAcigiBelgesiHazirlanmasiTalepEvrakForm.vue";
import RehininParayaCevrilmesiSerhiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/RehininParayaCevrilmesiSerhiTalepEvrakForm.vue";
import TasinmazHaczininKaldirilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/TasinmazHaczininKaldirilmasiTalepEvrakForm.vue";
import YuzuncuMaddeyeYararBilgiIstenilmesiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/YuzuncuMaddeyeYararBilgiIstenilmesiTalepEvrakForm.vue";
import {
  TopluHacizHazirlaTaskHandler
} from "@/plugins/uyap-plugin/store/modules/TaskHandler/TopluHacizHazirlaTaskHandler";
import {
  engelIsaretliGoreviSifirla,
  engelNedeniyleKes,
  engeleTakilanGorevleriIsaretle
} from "@/utils/uyapEngelDongu";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {VarsayilanGenel} from "@/classes/uyapTalep/VarsayilanGenel";
import {borcluEksikleri, TalepEksigi} from "@/classes/uyapTalep/DigerTalepZorunluAlanlar";
import _ from "lodash";
import NewFormDialog from "@/components/dialogs/NewFormDialog.vue";
import NewFormWrapper from "@/components/NewFormWrapper.vue";
import DosyaninIslemdenKaldirilmasiTalepEvrakForm
  from "@/components/forms/uyap-evrak/diger-evrak/DosyaninIslemdenKaldirilmasiTalepEvrakForm.vue";
import TopluTebligatDuzenleForm from "@/components/eicrapro/TopluTebligatDuzenleForm.vue";
import TopluGenelTalepDuzenleForm from "@/components/eicrapro/TopluGenelTalepDuzenleForm.vue";

@Component({
  components: {
    TopluGenelTalepDuzenleForm,
    TopluTebligatDuzenleForm,
    DosyaninIslemdenKaldirilmasiTalepEvrakForm,
    NewFormWrapper,
    NewFormDialog,
    YuzuncuMaddeyeYararBilgiIstenilmesiTalepEvrakForm,
    TasinmazHaczininKaldirilmasiTalepEvrakForm,
    RehininParayaCevrilmesiSerhiTalepEvrakForm,
    RehinAcigiBelgesiHazirlanmasiTalepEvrakForm,
    MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiTalepEvrakForm,
    MaasUzerindekiHacizlerinKaldirilmasiTalepEvrakForm,
    KiymetTakdirininYapilmasiTalepEvrakForm,
    Iik150cSerhiEklenmesiTalepEvrakForm,
    Iik121MaddeyeGoreYetkiVerilmesiTalepEvrakForm,
    HaricenTahsilatBildirimiTalepEvrakForm,
    HacizliTasinirMallarinMuhafazaAltinaAlinmasiTalepEvrakForm,
    HacizliMalinSatisiIcinTalimatYazilmasiTalepEvrakForm,
    HacizliMalinKiymetTakdiriIcinTalimatYazilmasiTalepEvrakForm,
    DosyaninYetkiliIcraDairesineGonderilmesiTalepEvrakForm,
    DosyadakiIbanBilgisininGuncellenmesiTalepEvrakForm,
    DosyadakiHacizlerinKaldirilmasiTalepEvrakForm,
    DosyadakiAvansinIadesiTalepEvrakForm,
    DosyadaHacizliMalinSatisiTalepEvrakForm,
    BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiTalepEvrakForm,
    BankadanHacizliParaninIstenilmesiTalepEvrakForm,
    AracUzerindekiYakalamaSerhininKaldirilmasiTalepEvrakForm,
    AracUzerindekiHacizSerhininKaldirilmasiTalepEvrakForm,
    AcizBelgesiHazirlanmasiTalepEvrakForm,
    PersonelPicker,
    AvukatTalepPicker,
    GenelIslemFormWizard
  }
})
export default class TopluGenelTalepHazirlaFormWizard extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: VForm;
  @Ref('genelIslemForm') genelIslemForm!: GenelIslemFormWizard;

  localValue: GenelIslemEntity = new GenelIslemEntity();
  taskDurum = TaskDurum;
  topluGenelDurum = TopluGenelDurum;
  durum: TopluGenelDurum = this.topluGenelDurum.bosta;
  genelEvrakTuru = UyapDigerEvrakTuru;
  valid = false;
  onFly = false;
  hideNext = false;
  talepler: Array<AvukatTalepListCevapRow> = [];
  message = "";
  varsayilanTalepler = new VarsayilanGenel();
  sadeceEksikler = false;
  duzenlemeAcik = false;
  duzenlenenBorclu: any = null;
  duzenlenenHedef: any = null;
  duzenlemeBasligi = "";

  stepperHeaders = [
    "Listelenecek Takipler",
    "Takipleri Seç",
    "Genel Talepleri Hazırla",
    "Genel Talepleri Gönder",
    "İşlemler Sıraya Alındı"
  ];
  secilenHeaders = [
    {text: "Birim Adı", value: "birimAdi"},
    {text: "Dosya Esas No", value: "dosyaNo"},
    {text: "Açılış Tarihi", value: "dosyaAcilisTarihi"},
    {text: "Dosya Durumu", value: "dosyaDurumAciklama"}
    /*{text: "Durum", value: "status", align: 'center'}*/
  ];
  talepDuzenleHeaders = [
    {text: "", value: "select", sortable: false, width: "50"},
    {text: "Dosya", value: "dosya", sortable: false},
    {text: "Borçlu", value: "borclu", sortable: false},
    {text: "Durum", value: "durum", sortable: false, width: "140"},
    {text: "İşlemler", value: "actions", width: "50", sortable: false}
  ];

  @Watch('localValue.secilen_takipler')
  async onSecilenTakiplerChange() {
    console.log("onSecilenTakiplerChange")
    let secilenTakip: any;
    for (secilenTakip of this.localValue.secilen_takipler) {
      if (!secilenTakip.task) {
        let task = new Task();
        task.dosya_esas_no = secilenTakip.dosyaNo;
        task.birim_adi = secilenTakip.birimAdi;
        task.task_type_id = TaskTuru.toplu_haciz_hazirla;
        task.dosya_id = secilenTakip.dosyaId;
        // takip nesnesinde "task" diye bir alan yok; duz atama ile eklenirse Vue bu
        // alani ve altindaki tum agaci (response.borclular[].digerTalep...) izlemiyor,
        // talep duzenlenince ekran guncellenmiyordu. $set ile reaktif olarak eklenir.
        this.$set(secilenTakip, 'task', task);
        this.input();
      }
    }
  }

  onStepChange(stepNo: number) {
    if (stepNo == 3)
      this.hideNext = true;
    else
      this.hideNext = false;
  }

  onTalepChange() {
    console.log("onTalepChange")
    console.log("")
    this.localValue.secilen_takipler.forEach(takip => {
      if (takip.task && (takip.task.status == this.taskDurum.BITTI_BASARILI || takip.task.status == this.taskDurum.BITTI_HATALI))
        takip.task.status = this.taskDurum.SIRADA;
    })
    this.input();
  }

  setVarsayilanTalep(talepKod: number) {
    let talep = this.talepler.find(talepItem => talepItem.talepKodu == talepKod) as AvukatTalepListCevapRow;
    // Hazırlanamamış takiplerde response boş; tüm listede dönülürse döngü hata verip
    // kalan dosyalara varsayılan uygulanmadan kesiliyordu.
    for (let takip of this.hazirTakipler) {
      for (let borclu of (takip.task.response.borclular || [])) {
        this.varsayilanTalepler.setVarsayilanTalepler(borclu, [talep]);
      }
    }
  }

  async createGenelTalepHazirlaTask() {
    if (this.form.validate()) {
      this.onFly = true;
      this.durum = this.topluGenelDurum.hazirlaniyor;
      this.message = "Talepler hazırlanıyor..."
      for (let [index, takip] of Object.entries(this.localValue.secilen_takipler)) {
        // @ts-ignore
        let task: ITask = takip.task;
        if (!task.status) {
          task.status = TaskDurum.SIRADA;
        }
        // UYAP engeli (DEV-3572): önceki turda "hazırlanmadı" işaretlenen görev yeniden SIRADA olur; kilit sürüyorsa
        // UYAP'a hiç istek atmadan kesilir, bu ve kalan görevler "UYAP engeli nedeniyle hazırlanmadı" olur.
        engelIsaretliGoreviSifirla(task);
        if (engelNedeniyleKes()) {
          engeleTakilanGorevleriIsaretle(this.localValue.secilen_takipler, Number(index), true, false);
          this.input();
          break;
        }
        try {
          this.message = (Number(index) + 1) + ". dosyanın talepleri hazırlanıyor.";
          if (task.status == TaskDurum.SIRADA) {
            task.data = {hacizParams: {}, digerTalepParams: this.talepler};
            let handler = new TopluHacizHazirlaTaskHandler();
            let taskResult = await handler.handle(task);
            task = taskResult;
            task.status = this.taskDurum.BITTI_BASARILI;
          }
          this.message = Number(index + 1) + ". dosyanın varsayılan talepleri uygulanıyor."
          for (let borclu of task.response.borclular) {
            // DosyaBorclu'da "selected" alani yok; duz atama reaktif olmuyor.
            this.$set(borclu, 'selected', true);
            borclu = this.varsayilanTalepler.setVarsayilanTalepler(borclu, this.talepler);
          }
          this.message = Number(index + 1) + ". dosyanın talepleri hazır."
        } catch (err) {
          if (engelNedeniyleKes(err)) {
            engeleTakilanGorevleriIsaretle(this.localValue.secilen_takipler, Number(index), true);
            break;   // finally (this.input()) yine çalışır
          }
          task.status = this.taskDurum.BITTI_HATALI;
          this.message = Number(index + 1) + ". dosyanın talepleri hazırlanırken hata oluştu. (" + err + ")"
          task.description = err;
        } finally {
          this.input();
        }
      }
      this.durum = this.topluGenelDurum.hazir;
      this.genelIslemForm.nextStep();
      this.onFly = false;
    }
  }

  showTalep(talepKod: UyapDigerEvrakTuru): boolean {
    return !!this.talepler.find((talep: AvukatTalepListCevapRow) => (talep.talepKodu == talepKod));
  }

  /* ---- Eksik talep bilgisi kontrolü ----
     Kullanıcı varsayılan talep ayarlarını hiç açmadan "Talepleri Gönder"e basabildiği
     için talep UYAP'a boş gidiyor, UYAP talebi oluşturmuyor ama işlem başarılı
     görünüyordu. Zorunlu alanlar DIGER_TALEP_ZORUNLU_ALANLAR'da tek yerde tanımlı. */

  get talepKodlari(): Array<number> {
    return this.talepler.map((talep: AvukatTalepListCevapRow) => talep.talepKodu);
  }

  get hazirTakipler(): Array<any> {
    return this.localValue.secilen_takipler.filter((takip: any) => takip.task && takip.task.status == this.taskDurum.BITTI_BASARILI);
  }

  /** Gönderilecek (seçili) borçlular */
  get gonderilecekBorclular(): Array<any> {
    let borclular: Array<any> = [];
    for (let takip of this.hazirTakipler)
      for (let borclu of takip.task.response.borclular)
        if (borclu.selected)
          borclular.push(borclu);
    return borclular;
  }

  eksikler(borclu: any): Array<TalepEksigi> {
    return borcluEksikleri(borclu, this.talepKodlari);
  }

  talepAdi(talepKodu: number): string {
    let talep = this.talepler.find((t: AvukatTalepListCevapRow) => t.talepKodu == talepKodu);
    return talep ? talep.talepAdi : '';
  }

  eksikMetni(borclu: any): string {
    return this.eksikler(borclu)
        .map((eksik: TalepEksigi) => this.talepAdi(eksik.talepKodu) + ': ' + eksik.alanlar.join(', '))
        .join('<br>');
  }

  /** Talep türü bazında, eksiği olan seçili borçlu sayısı */
  get talepEksikSayilari(): Record<number, number> {
    let sayilar: Record<number, number> = {};
    this.talepKodlari.forEach(talepKodu => sayilar[talepKodu] = 0);
    for (let borclu of this.gonderilecekBorclular)
      for (let eksik of this.eksikler(borclu))
        sayilar[eksik.talepKodu] = (sayilar[eksik.talepKodu] || 0) + 1;
    return sayilar;
  }

  talepRengi(talepKodu: number): string {
    return this.talepEksikSayilari[talepKodu] > 0 ? '#C62828' : '#2E7D32';
  }

  satirRengi(borclu: any): string {
    return this.eksikler(borclu).length > 0 ? '#C62828' : '#2E7D32';
  }

  /** Talep türü bazında gruplanmış özet; dosya başına ayrı uyarı üretmemek için */
  get eksikOzeti(): Array<{ talepKodu: number, talepAdi: string, alanlar: Array<string>, dosyaSayisi: number }> {
    let ozet: Record<number, { talepKodu: number, talepAdi: string, alanlar: Array<string>, dosyaSayisi: number }> = {};
    for (let borclu of this.gonderilecekBorclular) {
      for (let eksik of this.eksikler(borclu)) {
        if (!ozet[eksik.talepKodu])
          ozet[eksik.talepKodu] = {
            talepKodu: eksik.talepKodu,
            talepAdi: this.talepAdi(eksik.talepKodu),
            alanlar: [],
            dosyaSayisi: 0
          };
        ozet[eksik.talepKodu].dosyaSayisi++;
        for (let alan of eksik.alanlar)
          if (!ozet[eksik.talepKodu].alanlar.includes(alan))
            ozet[eksik.talepKodu].alanlar.push(alan);
      }
    }
    return Object.keys(ozet).map(talepKodu => ozet[Number(talepKodu)]);
  }

  get eksikDosyaSayisi(): number {
    return this.gonderilecekBorclular.filter((borclu: any) => this.eksikler(borclu).length > 0).length;
  }

  get gonderimeHazir(): boolean {
    return this.eksikOzeti.length === 0;
  }

  /* ---- Satır bazında talep düzenleme ----
     Düzenleme formu ObjectInputMixin ile yalnızca yüzeysel kopya aldığı için doğrudan
     borçlunun digerTalep referansına yazıyordu; Vazgeç'e basılsa bile değişiklikler
     kalıcı oluyordu. Bu yüzden düzenleme bir taslak üzerinde yapılır. */

  borcluAdi(borclu: any): string {
    return borclu.isKisiBool
        ? (borclu.borcluBilgileri.adi + ' ' + borclu.borcluBilgileri.soyadi)
        : borclu.borcluBilgileri.kurumAdi;
  }

  duzenlemeyeBasla(takip: any, borclu: any) {
    this.duzenlenenHedef = borclu;
    // Yalnızca talep alanları düzenleniyor; sorgu sonuçlarını kopyalamaya gerek yok.
    this.duzenlenenBorclu = Object.assign({}, borclu, {digerTalep: _.cloneDeep(borclu.digerTalep)});
    this.duzenlemeBasligi = takip.dosyaNo + ' - ' + takip.birimAdi + ' / ' + this.borcluAdi(borclu);
    this.duzenlemeAcik = true;
  }

  duzenlemeKapat() {
    this.duzenlemeAcik = false;
    this.duzenlenenBorclu = null;
    this.duzenlenenHedef = null;
  }

  duzenlemeKaydet() {
    if (this.duzenlenenHedef && this.duzenlenenBorclu) {
      let taslak = this.duzenlenenBorclu.digerTalep;
      for (let anahtar of Object.keys(taslak))
        this.$set(this.duzenlenenHedef.digerTalep, anahtar, taslak[anahtar]);
      this.input();
    }
    this.duzenlemeKapat();
  }

  /** Tablo satırları; filtre açıkken yalnızca eksiği olanlar. index orijinal dizideki sırayı korur. */
  gosterilecekSatirlar(takip: any): Array<{ borclu: any, index: number }> {
    let satirlar = takip.task.response.borclular.map((borclu: any, index: number) => ({borclu, index}));
    if (!this.sadeceEksikler)
      return satirlar;
    return satirlar.filter((satir: { borclu: any }) => this.eksikler(satir.borclu).length > 0);
  }

  async createTask() {
    try{
      this.onFly = true;
      // Buton zaten kilitli; buraya ancak beklenmedik bir durumda düşülür.
      if (!this.gonderimeHazir) {
        this.sadeceEksikler = true;
        this.$toast.warning('Eksik talep bilgisi olan dosyalar var. Gönderim öncesi tamamlayınız.');
        this.onFly = false;
        return;
      }
      let borcluSecildiMi = false;
      let tasks: Array<Task> = [];
      let takip: any;
      for (takip of this.localValue.secilen_takipler.filter(x=>x.task.status == this.taskDurum.BITTI_BASARILI)) {
        for (let borclu of takip.task.response.borclular) {
          if (borclu.selected) {
            let dosya = Object.assign({},takip.task.response.dosya);
            delete dosya.borclular;
            delete borclu.tebligat;
            delete borclu.haciz;
            borcluSecildiMi = true;
            let task: Task = new Task();
            task.dosya_esas_no = takip.dosyaNo;
            task.birim_adi = takip.birimAdi;
            task.dosya_id = takip.dosyaId;
            task.task_type_id = TaskTuru.toplu_genel_talep_hazirla;
            task.data = {
              dosya: takip.task.response.dosya,
              params: takip.task.response.params,
              borclu: borclu
            };
            tasks.push(task);
          }
        }
      }
      if (borcluSecildiMi) {
        let res = await this.$store.dispatch('postTasks', tasks);
        if (this.$store.getters.getAutoPlay)
          await this.$router.push(ProgramPaths.eicrapro + '/genel-talep-gonder-detay/' + res.data.id);
        else
          await this.$router.push(ProgramPaths.eicrapro + '/islemler');
        this.genelIslemForm.activeStep++;
      } else
        this.$toast.warning('Talep gönderilecek borçlu seçiniz.')
      this.onFly = false;
    }catch (e) {
      console.log(e);

    }
  }
}

enum TopluGenelDurum {
  bosta = 1,
  hazirlaniyor = 2,
  hazir = 3
}
